(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || typeof drawer.showModal !== 'function') return;
  const root = drawer.dataset.root;
  let opener;
  let pending = false;
  const message = text => { drawer.querySelector('[data-cart-message]').textContent = text; };
  const report = error => message(['TimeoutError', 'AbortError'].includes(error.name) ? drawer.dataset.timeout : error.message && !/[\u3400-\u9fff]/u.test(error.message) ? error.message : drawer.dataset.error);
  const open = () => {
    if (drawer.open) return;
    opener = document.activeElement;
    drawer.showModal();
    document.documentElement.classList.add('sf-cart-is-open');
  };
  const setBusy = busy => {
    pending = busy;
    drawer.setAttribute('aria-busy', String(busy));
    drawer.querySelectorAll('[data-cart-step], [data-cart-remove], [data-cart-quantity], button[name="checkout"]').forEach(control => { control.disabled = busy; });
  };
  const render = html => {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.querySelector('[data-cart-content]');
    if (!content) throw new Error(drawer.dataset.error);
    drawer.querySelector('[data-cart-content]').replaceWith(content);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = content.dataset.itemCount; });
  };
  const refresh = async () => {
    const response = await fetch(`${root}?section_id=sf-cart-drawer`, { headers: { Accept: 'text/html' }, signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error(drawer.dataset.error);
    render(await response.text());
  };
  const request = async (path, body) => {
    const response = await fetch(`${root}cart/${path}.js`, { method: 'POST', signal: AbortSignal.timeout(15000), headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: 'sf-cart-drawer', sections_url: window.location.pathname }) });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : drawer.dataset.error);
    if (data.sections?.['sf-cart-drawer']) render(data.sections['sf-cart-drawer']);
    else await refresh();
  };
  const change = async (line, quantity, focusSelector) => {
    if (pending || !Number.isInteger(quantity) || quantity < 0) return;
    setBusy(true);
    message(drawer.dataset.loading);
    try {
      await request('change', { id: line.dataset.cartLine, quantity });
      message(drawer.dataset.updated);
      setBusy(false);
      const currentLine = Array.from(drawer.querySelectorAll('[data-cart-line]')).find(el => el.dataset.cartLine === line.dataset.cartLine);
      (currentLine?.querySelector(focusSelector) || drawer.querySelector('[data-cart-close]')).focus();
    } catch (error) { report(error); }
    finally { setBusy(false); }
  };
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-cart-open]');
    if (trigger) {
      event.preventDefault();
      open();
      if (pending) return;
      setBusy(true);
      message(drawer.dataset.loading);
      try { await refresh(); message(''); } catch (error) { report(error); }
      finally { setBusy(false); }
      return;
    }
    if (event.target.closest('[data-cart-close]')) { drawer.close(); return; }
    const step = event.target.closest('[data-cart-step]');
    const remove = event.target.closest('[data-cart-remove]');
    if (step || remove) {
      const line = (step || remove).closest('[data-cart-line]');
      const input = line.querySelector('[data-cart-quantity]');
      const quantity = remove ? 0 : Math.max(0, Number(input.value) + Number(step.dataset.cartStep));
      await change(line, quantity, step ? `[data-cart-step="${step.dataset.cartStep}"]` : '[data-cart-quantity]');
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-sf-product-form]');
    if (!form) return;
    event.preventDefault();
    if (pending) return;
    const data = new FormData(form);
    const button = form.querySelector('[type="submit"]');
    const item = { id: data.get('id'), quantity: Number(data.get('quantity') || 1) };
    const properties = {};
    for (const [key, value] of data) { const match = key.match(/^properties\[(.*)\]$/); if (match) properties[match[1]] = value; }
    if (Object.keys(properties).length) item.properties = properties;
    if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
    open();
    setBusy(true);
    button.disabled = true;
    message(drawer.dataset.loading);
    try { await request('add', { items: [item] }); message(drawer.dataset.added); }
    catch (error) { report(error); }
    finally { setBusy(false); button.disabled = false; }
  });
  drawer.addEventListener('change', async event => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input || pending) return;
    if (input.value.trim() === '') {
      input.value = input.defaultValue;
      return;
    }
    if (!input.checkValidity() || !Number.isInteger(Number(input.value))) { input.reportValidity(); return; }
    await change(input.closest('[data-cart-line]'), Number(input.value), '[data-cart-quantity]');
  });
  drawer.addEventListener('click', event => { if (event.target === drawer) { const rect = drawer.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right) drawer.close(); } });
  drawer.addEventListener('close', () => { document.documentElement.classList.remove('sf-cart-is-open'); message(''); if (opener?.isConnected) opener.focus(); });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh().catch(() => {}); });
})();
